// extracted by mini-css-extract-plugin
export default {"containerWrapper":"Others_containerWrapper__azXM1","container":"Others_container__gst4E","heading1":"Others_heading1__HSNSN","normalText":"Others_normalText__BG1Bv"};